/* tslint:disable */
import { enableProdMode, NgModuleRef, ApplicationRef, ErrorHandler } from '@angular/core';
import { disableDebugTools } from '@angular/platform-browser';
import { Environment } from './model';

import * as Inflection from 'inflection'

import {
  Utils,
  RedirectHelper,
  DomUtils,
  MergedExceptionHandlerBuilder,
  MergedExceptionHandler,
} from '@mprep/shared'

import { LOGIN_URL,  LOGOUT_URL, VENDOR_SERVICE_CONFIG } from '../app/shared'

const utils = new Utils(window, Inflection)
const redirectHelper = new RedirectHelper(LOGIN_URL, LOGOUT_URL, window)
const domUtils = new DomUtils(window)
const mergedExceptionHandlerBuilder = new MergedExceptionHandlerBuilder(redirectHelper, utils, domUtils, {
  endpoint: VENDOR_SERVICE_CONFIG.SENTRY.endpoint,
  releaseVersionId: RELEASE_VERSION_ID,
  environment: ENVIRONMENT_ID
})
const handler = mergedExceptionHandlerBuilder.productionBuild()

enableProdMode();

export const environment: Environment = {
  production: true,
  showDevModule: false,

  /** Angular debug tools in the dev console
   * https://github.com/angular/angular/blob/86405345b781a9dc2438c0fbe3e9409245647019/TOOLS_JS.md
   * @param modRef
   * @return {any}
   */
  decorateModuleRef(modRef: NgModuleRef<any>) {
    disableDebugTools();
    return modRef;
  },
  ENV_PROVIDERS: [
    { provide: ErrorHandler, useValue: handler },
    { provide: MergedExceptionHandler, useValue: handler }
  ]
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts